'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useAuth } from '@hooks/useAuth';

/**
 * Point d'entrée : oriente vers /login ou vers l'accueil collaborateur.
 *
 * Deux points d'entrée coexistent, comme dans la maquette — collaborateur et back-office —
 * mais l'accueil collaborateur est le seul *atterrissage* : un administrateur SI détient lui
 * aussi un ordinateur et doit le déclarer. Le back-office se rejoint depuis l'accueil.
 */
export default function RootPage() {
  const auth = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (auth.status === 'unauthenticated') {
      router.replace('/login');
    } else if (auth.status === 'authenticated') {
      router.replace('/accueil');
    }
  }, [auth, router]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-tertiary text-sm">Chargement…</p>
    </div>
  );
}
